import React from 'react';
import PropTypes from 'prop-types';
import Dialog from '../../common/components/dialog/Dialog';
import Button, { ButtonGroup } from '../../common/components/dialog/Buttons';
import styled from 'styled-components';

import variables from '../../common/variables';

const Text = styled.div`
  font-size: 14px;
  color: ${variables.colors.black};
  line-height: 1.4em;
  margin-bottom: 20px;
`;

const close = () => {
  if (window.opener !== null || window.history.length === 1) {
    window.close();
  } else {
    window.location.href = '/dashboard';
  }
};

export const GoogleDriveErrorDialog = ({ message, onAction }) => (
  <Dialog visible title={message.title} onClose={close}>
    <Text>{message.message}</Text>
    <ButtonGroup>
      <Button color="transparent" onClick={close}>
        Cancel
      </Button>
      <Button color="blue" onClick={onAction}>
        {message.action}
      </Button>
    </ButtonGroup>
  </Dialog>
);

GoogleDriveErrorDialog.propTypes = {
  message: PropTypes.shape({
    title: PropTypes.string,
    message: PropTypes.string,
    action: PropTypes.string,
  }).isRequired,
  onAction: PropTypes.func.isRequired,
};
